import { observable, action, makeObservable } from "mobx";
import { taskAttachmentsStore } from "./TaskAttachmentsStore";

class TaskModalStore {
  isVisible: boolean = false;
  from: "docs" | "task" = "task";

  constructor() {
    makeObservable(this, {
      isVisible: observable,
      from: observable,
      toggleModal: action.bound,
      clear: action.bound,
    });

    this.isVisible = false;
  }

  toggleModal(from: "docs" | "task" = "task", forceClose?: boolean) {
    if (forceClose) {
      this.clear();
      taskAttachmentsStore.clearAll();
    } else {
      this.from = from;
      this.isVisible = !this.isVisible;
    }
  }

  clear() {
    this.from = "task";
    this.isVisible = false;
  }
}

const taskModalStore = new TaskModalStore();

export { taskModalStore, TaskModalStore };
